import axios from "axios";
import {
  getActiveRegion,
  getRegion,
  REGIONS,
  tokenKeyFor,
} from "@/config/regions";
import { resolveTokenForRegion } from "@/lib/auth-tokens";

export type RegionCode = string;

export const getTokenForRegion = (code: RegionCode): string | null => {
  return resolveTokenForRegion(code);
};

export const getBaseUrlForRegion = (code: RegionCode): string => {
  return getRegion(code)?.baseUrl ?? REGIONS[0].baseUrl;
};

const getInstance = () => localStorage.getItem("instance");

const api = axios.create({
  baseURL: REGIONS[0]?.baseUrl,
});

api.interceptors.request.use(
  (config) => {
    const region = getActiveRegion();
    const token = getTokenForRegion(region.code);
    const instance = getInstance();

    config.baseURL = region.baseUrl;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (instance) {
      config.headers.Instance = instance;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config, response } = error;
    if (
      response?.status === 401 &&
      !config?.url?.startsWith("/auth/signin") &&
      !config?.url?.startsWith("/auth/2fa")
    ) {
      const region = getActiveRegion();
      localStorage.removeItem(tokenKeyFor(region.code));
      localStorage.removeItem("token");
      window.location.assign("/login");
    }
    return Promise.reject(error);
  },
);

export default api;
